var _rect, _rect2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPostodetrabalho(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 25.5,
    height: 25.5,
    rx: 12.75,
    fill: "url(#pattern0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 25.5,
    height: 25.5,
    rx: 12.75,
    stroke: "white",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1874_50994",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1874_50994",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,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"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostodetrabalho);
export default __webpack_public_path__ + "static/media/postodetrabalho.b72f0ef7aca4f1db7dbc02626b7a7759.svg";
export { ForwardRef as ReactComponent };